import { Flex, Icon } from '@chakra-ui/react';
import React from 'react';
import './copyFrom.css';
import { HtmlRenderer } from '../HtmlRenderer';
import { Scorecard } from '@/assets/icons/ats/empty';
import { KText } from '@/ui-library/components';

export default function JobDescriptionCopy({ job = {}, selectedJob }) {
  const { job_description = '', name } = job;

  const errorMessage = 'Select a job to know its description';

  if (!selectedJob?.id)
    return (
      <Flex alignItems="center" justifyContent="center" w="100%">
        <KText fontSize="14" fontWeight="medium" mb="1em">
          {errorMessage}
        </KText>
      </Flex>
    );

  return (
    <Flex flexDir="column" p="20px 30px" h="100%" w="100%">
      <KText
        fontSize="28px"
        fontWeight="medium"
        mb="1em"
        lineHeight={'none'}
        color="secondary-900"
      >
        {name}
      </KText>
      {job_description ? (
        <>
          <HtmlRenderer htmlString={job_description} className="editor-style" />
        </>
      ) : (
        <Flex
          w="100%"
          h="90%"
          flexDir="column"
          alignItems="center"
          justifyContent="center"
        >
          <Icon as={Scorecard} w="150px" h="115px" />
          <KText size="sm-medium" mt="36px" mb="9px">
            LOOKS EMPTY IN HERE
          </KText>
          <KText size="lg-semi-bold">No job description found</KText>
        </Flex>
      )}
    </Flex>
  );
}
